import formatNumber from "../../utils/formatNumber";
import React from "react";
import styles from "./styles.module.scss";

function ChartInfo({ data, note }) {
    let reversedInfos = data.infos.slice();

    return (
        <div className={styles.infoContainer}>
            {reversedInfos.map((info, index) => (
                <div key={info.title} className={styles.infoItem}>
                    <p>
                        {index === 0 ? "製圖的項目" : `分類的項目${index}`}：
                        {info.title}
                    </p>
                    {info.remark && <p>註解：{info.remark}</p>}
                </div>
            ))}
            <div className={styles.infoItem}>
                <p>遺漏值(含不知道、不記得與拒答)：{formatNumber(data.missing)}</p>
                <p>有效樣本：{formatNumber(data.numbern)}</p>         
                
                <p>
                    本調查依據母體比率進行加權後四捨五入至整數，有效樣本數為各項欄位權重數值的總和。由於四捨五入可能產生的數值誤差，如想取得調查原始數據可至首頁/資料來源申請。
                </p>
            </div>
            <ul>
                <li>
                    資料來源：國家災害防救科技中心減災動資料 0918 池上地震花東地區-地震認知與避難行為調查。
                </li>
            </ul>
            {note && <p>{note}</p>}
        </div>
    );
}

export default ChartInfo;